import { isUndefined, unset, set } from 'lodash';

const hasValue = <T = unknown>(v: T): boolean => v !== '' && !isUndefined(v);

/**
 * Set value to source object by path
 * @param source - source object
 * @param path - path to set value
 * @param value - value to set. If value is undefined or '', then path will be removed from source object
 * @returns void
 *
 * @example
 * const source = { a: { b: { c: 1 } } };
 * setValue(source, 'a.b.c', 2);
 * console.log(source); // { a: { b: { c: 2 } } }
 */
function setValue<Source extends object, Value = unknown>(source: Source, path: string, value: Value) {
	if (hasValue(value)) set(source, path, value);
	else unset(source, path);
}

export { setValue, hasValue };
